import React, { useEffect, useState, useRef } from "react";
import {
  createSearch,
  deleteSearch,
  deleteServices,
  editServices,
  getSearch,
  getServices,
  updateSearch,
} from "../../services/Admin/adminServices";
import Dropdown from "react-bootstrap/Dropdown";
import { Button, Modal, Form } from "react-bootstrap";
import toast from "react-hot-toast";
import { Formik, Field, Form as FormikForm, ErrorMessage } from "formik";
import * as Yup from "yup";

import { useNavigate } from "react-router-dom";
import Pagination from "../components/Pagination";
import Spinner from "../components/Common/Spinner";
import LocationSearchDropdown from "../components/LocationDropDown";
import { debounce } from "lodash";
import LocationAdd from "../components/LocationAdd";
import { uploadFileToS3 } from "../../../lib/S3Bucket";

const Subjects = () => {
  const [service, setService] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [search, setSearch] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const navigate = useNavigate();
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmData, setConfirmData] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  const getservices = async () => {
    try {
      setLoading(true);

      const response = await getSearch(currentPage, 10, debouncedSearch);

      setService(response?.data?.data?.categorys);

      setTotalItems(response?.data?.data?.total);
    } catch (error) {
      console.error("errors", error);
    } finally {
      setLoading(false);
    }
  };

  const handleView = (serviceItem) => {
    setSelectedService(serviceItem);
    setShowModal(true);
    if (serviceItem?.image) {
      setImagePreview(serviceItem.image);
    } else {
      setImagePreview("");
    }
  };
  const handleClose = () => {
    setShowModal(false);
    setSelectedService(null);
    setImagePreview("");
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  
  const openDeleteConfirm = (serviceItem) => {
    setConfirmData(serviceItem);
    setConfirmModal(true);
  };

  const confirmDelete = async () => {
    try {
      await deleteSearch(confirmData._id);

      setService((prev) =>
        prev.filter((s) => s._id !== confirmData._id)
      );

      setTotalItems((prev) => prev - 1);

      toast.success("Subject deleted successfully");

    } catch (error) {
      toast.error("Failed to delete subject");
      console.error(error);
    } finally {
      setConfirmModal(false);
      setConfirmData(null);
    }
  };

  useEffect(() => {
    setCurrentPage(0)
    const handler = debounce(() => {
      setDebouncedSearch(search);
    }, 500);

    handler();

    return () => {
      handler.cancel();
    };
  }, [search]);

  const boxColors = [
    "#BBB3CA",
    "#DBC8CA",
    "#C8DBD7",
    "#ECD5A1",
    "#DBC8CA",
    "#ECD5A1",
    "#C8DBD7",
  ];
  const getRandomColor = () => {
    const randomIndex = Math.floor(Math.random() * boxColors.length);
    return boxColors[randomIndex];
  };

  useEffect(() => {
    getservices();
  }, [currentPage, debouncedSearch]);
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const handleFileUpload = async (e, fieldName, setFieldValue) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      setUploading(true);
      const key = `uploads/${Date.now()}-${file.name}`;
      const res = await uploadFileToS3(file, key);

      if (res) {
        setImagePreview(URL.createObjectURL(file)); 
        setFieldValue(fieldName, res);
      }
    } catch (error) {
      toast.error("File upload failed");
      setImagePreview("");
    } finally {
      setUploading(false);
    }
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("title is required"),
    image: Yup.string().required("Image is required"),
  });
  const initialFormValues = {
    name: "",
    image: "",
  };
  return (
    <div>
      <h1 style={{ color: "#87C55F" }}>Category</h1>
      <div className=" pb-2 d-flex flex-wrap justify-content-between gap-2 align-items-center mb-4">
        <div className="flex-grow-1">
          <input
            type="text"
            style={{ borderRadius: "0.5rem", borderColor: "#87C55F" }}
            className="form-control w-100"
            placeholder="Search....."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div>
          <button
            className="btn"
            style={{
              backgroundColor: "#87C55F",
              color: "white", // text color
              border: "none", // remove border
              padding: "8px 16px", // optional padding
              borderRadius: "4px",
              marginBottom: "4px", // optional rounded corners
            }}
            onClick={() => setShowModal(true)}
          >
            Add new
          </button>
        </div>
      </div>
      {loading ? (
        <Spinner />
      ) : service.length === 0 ? (
        <p>No category available.</p>
      ) : (
        <div className="row">
          {service.map((serviceItem, index) => (
            <div className="col-md-3 mb-4" key={serviceItem._id || index}>
              <div
                style={{
                  backgroundColor: getRandomColor(),
                  borderRadius: "12px",
                }}
                className={`card shadow-lg card-custom  position-relative`}
              >
                <div className="card-body d-flex justify-content-between align-items-start">
                  <div className="d-flex align-items-center gap-3">
                    <img
                      src={serviceItem?.image || `https://ui-avatars.com/api/?name=${serviceItem?.name || "Subject"}&background=87C55F&color=fff`}
                      alt={serviceItem?.name}
                      style={{
                        width: "50px",
                        height: "50px",
                        objectFit: "cover",
                        borderRadius: "8px",
                        border: "1px solid #eaeaea"
                      }}
                    />
                    <div>
                      <h5 className="card-title mb-1">{serviceItem.name}</h5>
                      <p className="card-text mb-0" style={{ color: "gray", fontSize: "0.85rem" }}>
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="#1111111"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ marginRight: "4px" }}
                        >
                          <path
                            d="M7 2V5M17 2V5M3 9H21M5 4H19C20.1046 4 21 4.89543 21 6V20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20V6C3 4.89543 3.89543 4 5 4Z"
                            stroke="#6c757d"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>{" "}
                        {new Date(serviceItem.createdAt).toLocaleDateString(
                          "en-IN",
                          {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          },
                        )}
                      </p>
                    </div>
                  </div>
                  <Dropdown align="end">
                    <Dropdown.Toggle
                      variant="light"
                      id={`dropdown-basic-${index}`}
                      style={{ padding: "4px 8px" }}
                    >
                      {svg1}
                    </Dropdown.Toggle>

                    <Dropdown.Menu align="end">
                      <Dropdown.Item onClick={() => handleView(serviceItem)}>
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() =>
                          navigate(`/sub-category/${serviceItem?._id}`)
                        }
                      >
                        Sub-Category
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => openDeleteConfirm(serviceItem)}
                      >
                        Delete
                      </Dropdown.Item>

                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {service?.length > 0 ? (
        <div className="card-footer clearfix">
          <div className="d-flex justify-content-between align-items-center">
            <div className="dataTables_info" style={{ color: "#87C55F" }}>
              Showing {currentPage * itemsPerPage + 1} to{" "}
              {totalItems > (currentPage + 1) * itemsPerPage
                ? (currentPage + 1) * itemsPerPage
                : totalItems}{" "}
              of {totalItems} entries
            </div>
            <div className="d-flex align-items-center" style={{ gap: "10px" }}>
              <Pagination
                pageCount={totalPages}
                pageValue={currentPage}
                setPage={setCurrentPage}
              />
            </div>
          </div>
        </div>
      ) : (
        ""
      )}

      <Modal show={showModal} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#87C55F" }}>
            {selectedService ? "Edit Subject" : "Add New Subject"}
          </Modal.Title>
        </Modal.Header>

        <Formik
          initialValues={
            selectedService
              ? {
                  _id: selectedService._id,
                  name: selectedService.name || "",
                  image: selectedService.image || "",
                }
              : initialFormValues
          }
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={async (values, { setSubmitting }) => {
            try {
              if (selectedService) {
                const payload = {
                  categoryId: values._id,
                  name: values.name,
                  image: values.image,
                };
                // 🔄 Update
                await updateSearch(payload);
                toast.success("Updated successfully");
              } else {
                const payload = {
                  name: values?.name,
                  image: values?.image,
                };
                await createSearch(payload);
                toast.success("Added successfully");
              }
              handleClose();
              getservices();
            } catch (error) {
              toast.error(error?.response?.data?.message);
              console.error(error);
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({ isSubmitting, setFieldValue, value }) => (
            <FormikForm>
              <Modal.Body>
                {/* Title */}
                <Form.Group className="mb-3">
                  <Form.Label>Title</Form.Label>
                  <Field
                    name="name"
                    className="form-control"
                    placeholder="ex. Anatomy"
                    style={{ borderColor: "#87C55F" }}
                  />
                  <ErrorMessage
                    name="name"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>

                {/* Image Upload */}
                <Form.Group className="mb-3">
                  <Form.Label>Image {uploading && "(Uploading...)"}</Form.Label>
                  <input
                    type="file"
                    accept="image/*"
                    className="form-control"
                    style={{ borderColor: "#87C55F" }}
                    ref={fileInputRef}
                    onChange={(e) => handleFileUpload(e, "image", setFieldValue)}
                  />
                  <small className="text-muted d-block mt-1">
                    Max file size: 5MB. Supported formats: JPG, PNG, GIF, WebP
                  </small>
                  <ErrorMessage
                    name="image"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>

                {imagePreview && (
                  <div className="mb-3 text-center mt-3">
                    <div
                      style={{ display: "inline-block", position: "relative" }}
                    >
                      <img
                        src={imagePreview}
                        alt="preview"
                        style={{
                          width: "120px",
                          height: "120px",
                          objectFit: "cover",
                          borderRadius: "10px",
                          border: "1px solid #ddd",
                        }}
                      />

                      <button
                        type="button"
                        className="btn btn-danger btn-sm shadow"
                        style={{
                          position: "absolute",
                          top: "-8px",
                          right: "-8px",
                          borderRadius: "50%",
                          width: "24px",
                          height: "24px",
                          padding: "0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          lineHeight: "1",
                          fontSize: "16px",
                          fontWeight: "bold",
                        }}
                        onClick={() => {
                          setImagePreview("");
                          if (fileInputRef.current) {
                            fileInputRef.current.value = "";
                          }
                          setFieldValue("image", "");
                        }}
                      >
                        &times;
                      </button>
                    </div>
                  </div>
                )}
              </Modal.Body>

              <Modal.Footer>
                <Button
                  type="submit"
                  disabled={isSubmitting || uploading}
                  style={{ backgroundColor: "#87C55F", border: "none" }}
                >
                  {selectedService ? "Update" : "Add"}
                </Button>
              </Modal.Footer>
            </FormikForm>
          )}
        </Formik>
      </Modal>
      <Modal
        show={confirmModal}
        onHide={() => setConfirmModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: "#dc3545" }}>
            Confirm Delete
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          Are you sure you want to delete subject{" "}
          <strong>{confirmData?.name}</strong>?
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setConfirmModal(false)}
          >
            Cancel
          </Button>

          <Button
            onClick={confirmDelete}
            style={{
              backgroundColor: "#dc3545",
              border: "none",
            }}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
};

export default Subjects;
